import "./App.css";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import DrawerLayout from "./componentes/DrawerLayout";
import RoutesMenus from "../routes";
import { AppProvider } from "./AppContext";
import RoutesControl from "./componentes/RoutesControl";
import MenuControl from "./componentes/MenuControl";
// import { BrowserRouter } from "react-router-dom";
import { HashRouter as Router } from 'react-router-dom';
import store from "../reducer";
import { Provider } from "react-redux";
import { Suspense, useEffect, useState } from "react";
import firebaseUtil from "../firebaseUtil";
import { CircularProgress } from "@mui/material";
import { salvarPerfilLogin } from "../dbApi";
import { NotificationProvider } from "notification";

export const theme = createTheme({
    typography: {
        useNextVariants: true,
    },
    palette: {
        primary: {
            main: "#830606",
            light: "#ffdddd",
            contrastText: "#fff",
        },
        secondary: {
            main: "#2d0c07",
            contrastText: "#fff",
        },
        tertiary: {
            main: "#03012b"
        }
    },
    components: {
        MuiButton: {
            defaultProps: {
                variant: "contained",
            },
        },
        MuiButtonGroup: {
            defaultProps: {
                variant: "contained",
            },
        },
    },
});

function App() {
    const [firebaseInitialized, setFirebaseInitialized] = useState(false);
    useEffect(() => {
        firebaseUtil.isInitialized().then((val) => {
            setFirebaseInitialized(val);
            if (val) {
                salvarPerfilLogin(val);
            }
        });
    }, []);
    return firebaseInitialized !== false ? (
        <Suspense fallback={<CircularProgress />}>
            <Provider store={store}>
                <Router>
                    <ThemeProvider theme={theme}>
                        <NotificationProvider>
                            <AppProvider>
                                <RoutesMenus />
                                <DrawerLayout RoutesContainer={RoutesControl} MenuContainer={MenuControl} />
                            </AppProvider>
                        </NotificationProvider>
                    </ThemeProvider>
                </Router>
            </Provider>
        </Suspense>
    ) : (
        <div className="loader">
            <CircularProgress />
        </div>
    );
}

export default App;
